'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityIntroCtrl', ActivityIntroCtrl);

  ActivityIntroCtrl.$inject = ['$log', '$state', 'trainSvc', 'focus'];

  /* @ngInject */
  function ActivityIntroCtrl($log, $state, trainSvc, focus) {
    var vm = this;
    vm.title = 'ActivityIntroCtrl';
    vm.$onInit = activate;

    ////////////////

    function activate() {
      $log.debug('ActivityIntro ctrl activate');
      trainSvc.getTrain().then(function (train) {
        vm.train = train;
        vm.percentComplete = {
          width: train.status.percentComplete + '%'
        };
        //should not get completed === trainLength, this is just-in-case because it has happened
        vm.activitiesComplete = train.status.completed === train.status.trainLength ? train.status.completed : train.status.completed + 1;
        vm.showProgress = shouldShowProgress(train);
      });
    }

    function shouldShowProgress(train) {
      if (train.status.trainLength === 1) return false;
      //Do not show if completed series
      if (train.activities.length === 1 && train.activities[0].type.name === 'ACTIVITY_SERIES' && train.activities[0].completed) {
        return false;
      }
      return true;
    }

    focus.byId('hero-title');
  }
})();